/**
 * Created by forbiz on 2019-02-11.
 */

import Swiper from 'swiper/dist/js/swiper'

const orderPayment = () => {
    const $window = $(window);
    const $document = $(document);

    // 주문결제 배송지정보 영역 이벤트
    const deliveryInfo = () => {

        // 배송요청사항 이벤트
        const directWrite = () => {
            $document
                .on('change', function() {
                    const val = $("#demandYn option:selected").val();   
                    const $textArea = $('.hd__custom-textarea');

                    if ( $('#demandYn').length >= 1 ) {
                        if ( val == "1" ) {
                            $textArea.show();
                        } else {
                            $textArea.hide();
                        }
                    }
                });
        };

        // 글자수 제한
        const limit_text = () => {
            $document
                .on("keyup", '.hd__custom-textarea textarea', function(){
                    const $this = $(this);
                    const $text_count = $(".text_count span");
                    if ($this.val().length > 30) {
                        $this.val($this.val().substring(0, 30));
                        $text_count.text(30);
                    } else {
                        $text_count.text($this.val().length);
                    }
                });
        };

        // 새벽배송 정보입력 radio check 이벤트
        const dawnDelivery = () => {
            const $infoBox = $('.dawnDelivery-info .infobox');
            const $home = $infoBox.find('input[name=home]');
            const $seOffice = $infoBox.find('input[name=seOffice]');
            const $visitWay = $infoBox.children('.visit-way');

            $home
                .on("change", function() {
                    const $this = $(this);
                    if( $this.prop('checked') == true ) {
                        $visitWay.addClass('show');
                        $seOffice.prop('checked', false);
                    } else {

                    }
                });

            $seOffice
                .on("change", function() {
                    const $this = $(this);
                    if( $this.prop('checked') == true ){
                        $visitWay.removeClass('show')
                        $home.prop('checked', false);
                    } else {
                        
                    }
                });

            $visitWay
                .on("change", function() {
                    const $checkArea = $visitWay.find('input[name=check]');
                    const $frontPW = $visitWay.find('input[id=visitWay1]');
                    const $inputArea = $visitWay.find('input[name=frontPWInput]');

                    if( $frontPW.prop('checked') == true ){
                        $inputArea.show();
                        $checkArea.prop('checked', false);
                        $frontPW.prop('checked', true);
                    } else {
                        $inputArea.hide();
                    }
                });
        };

        // 일반배송 체크 이벤트
        const normalDelivery = () => {
            $document
                .on('click', '.normal-delivery', function() {
                    const $this = $(this);
                    const $checkInput = $this.children('input[name=deliveryNormal]');
                    const $dawnDeliveryInfo = $('.dawnDelivery-info');
                    const $dawnDeliveryDesc = $('.dawnDelivery--desc');
                    const $dawnDeliveryDescType2 = $('.dawnDelivery--desc-type2');
                    
                    if( $checkInput.prop('checked') == true ) {
                        $this.addClass('on');
                        $dawnDeliveryInfo.hide();
                        $dawnDeliveryDesc.hide();
                        $dawnDeliveryDescType2.show();
                    } else {
                        $this.removeClass('on');
                        $dawnDeliveryInfo.show();
                        $dawnDeliveryDesc.show();
                        $dawnDeliveryDescType2.hide();
                    }
                });
        };

        // 일반상품 배송지 - 따로 배송받기
        const seperate = () => {
            const $seperate = $('.seperate');
            const $checkArea = $seperate.find('.seperate__checks');

            $checkArea
                .on('click', function() {
                    const $this = $(this);
                    const $checkInput = $this.children('input[name=deliSeperate]');
                    const $target = $('.seperate__cont');

                    if( $checkInput.prop('checked') == true ) {
                        $this.addClass('on');
                        $target.show();
                    } else {
                        $this.removeClass('on');
                        $target.hide();
                    }

                })

            $document
                .on('click', ".seperate .tab-list-v2", function() {
                    const $this = $(this);
                    const tab_name = $this.data('tab');
                    const $cont = $('#' + tab_name);
    
                    $this.addClass('tab-list-v2--on').siblings().removeClass('tab-list-v2--on');
                    $cont.addClass('current').siblings().removeClass('current');
    
                    return false;
                });
        }

        directWrite();
        limit_text();
        dawnDelivery();
        // normalDelivery();
        seperate();
    };

    // 주문결제 결제수단선택 클릭이벤트
    const paymentMethod = () => {
        let card_swiper = '';

        const payType = () => {
            $document
                .on('click', ".payMethod ul li", function() {
                    const $this = $(this);
    
                    $this.addClass('on').siblings().removeClass('on');
                });
        };

        const assoArea = () => {
            $document
                .on('click', ".assoPayBtn", function() {
                    const $this = $(this);
                    const $target = $this.siblings('.certi-area');
    
                    $target.show();
                });
        };

        const cardSlider = () => {
            const $target = $('.greating-pay__sec.card .card__wrap');

            if ($target.find('.card__list').length > 1) {
                card_swiper = new Swiper( $target, {
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: false,
                    },
                    slidesPerView: 1,
                });
            }
        };

        payType();
        assoArea();
        cardSlider();
    };

    const dawnDelivery = () => {
        $document
            .on('change', '[name="VISIT_TYPE"]', function() {
                var $this = $(this);
                
                if ( $this.is(':checked') ) {
                    $('.dawnDelivery-info .hd-checkbox-type2').siblings('[type="text"]').css('visibility', 'hidden').val('');
                    $this.closest('.hd-checkbox-type2').siblings('[type="text"]').css('visibility', '');
            
                    if ( $('.infobox').find('.alertBox').length > 0 ) {
                        $('.infobox').find('.alertBox').remove();
                    }
                }
            });
    };

    const floatingPay = () => {
        const $floating = $('.right-box');

        $window
            .on('load scroll', function() {
                const $this = $(this);
                const _st = $this.scrollTop();
                const _contTotal = $('.orderPayment__inner').offset().top + $('.orderPayment__inner').outerHeight(true);
                const _calc = _contTotal - (112 + $floating.children().height());

                if ( _st >= $floating.offset().top - 112 && _calc > _st ) {
                    $floating.removeClass('absolute').addClass('fixed');
                } else if ( _calc < _st && $floating.children().height() < $('.left-box').height() ) {
                    $floating.removeClass('fixed').addClass('absolute');
                } else {
                    $floating.removeClass('fixed absolute');
                }
            })
    };

    const accd = () => {
        $document
            .on('click', '.btn--listMore', function(e) {
                var $this = $(this);
                
                if ( !$this.hasClass('accordion__head--on') ) {
                    $this.text('펼쳐보기').next().stop().slideUp();
                } else {
                    $this.text('접어두기').next().stop().slideDown();
                }
                
                e.preventDefault();
            });
    }

    const orderPayment_init = () => {
        deliveryInfo();
        paymentMethod();
        dawnDelivery();
        floatingPay();
        accd();
    };

    orderPayment_init();
};

export default orderPayment;